import React, { useState, useEffect, useRef } from "react";
import { Button, FormLabel, TextField, Typography } from "@material-ui/core";
import { ReactComponent as ExportIcon } from "../images/commonicon/exporticon.svg";
import { ReactComponent as ImportIcon } from "../images/commonicon/importicon.svg";
import { ReactComponent as AllCommentIcon } from "../images/commonicon/commentbtnicon.svg";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../../crypto";
import Loader from "./Loader";
import useStyles from "../../styles";
import { toast } from "react-toastify";
import axios from "axios";

function TableViewSearch(props) {
  const navigate = useNavigate();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const classes = useStyles();
  const { Heading, onSearch, onDateSearch } = props;
  const [searchInput, setSearchInput] = useState("");
  const [dateInput, setDateInput] = useState("");
  const [isImporting, setIsImporting] = useState(false);
  const fileInputRef = useRef();

  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleFileInputChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    setIsImporting(true);

    try {
      const response = await axios.post(Heading[0].importApiUrl, formData, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success("File uploaded successfully");
        if (typeof Heading?.[0]?.fetchData === "function") {
          try {
            Heading[0].fetchData();
          } catch (err) {
            console.error("Error calling Heading fetchData:", err);
          }
        } else if (typeof props?.fetchData === "function") {
          try {
            props.fetchData();
          } catch (err) {
            console.error("Error calling props fetchData:", err);
          }
        }
      } else {
        throw new Error("Failed to upload the file");
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string" ? error?.response?.data : null) ||
        "An error occurred while uploading the file";
      toast.error(apiMessage);
    } finally {
      setIsImporting(false);
      // Reset input so the same file can be uploaded again immediately
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleExport = async () => {
    console.log(Heading);
    try {
      const response = await axios.get(Heading[0].exportApiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        if (response.data && response.data.file_url) {
          window.open(response.data.file_url, "_blank");
          toast.success("CSV has been downloaded successfully.");
        } else if (response.data) {
          const rawName = Heading?.[0]?.exportFileName || "Export";
          const fileName = rawName.endsWith(".csv") ? rawName : `${rawName}.csv`;
          const blob =
            response.data instanceof Blob
              ? response.data
              : new Blob([response.data], { type: "text/csv;charset=utf-8;" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          toast.success("CSV has been downloaded successfully.");
        } else {
          toast.error("Failed to download the CSV file.");
        }
      } else {
        toast.error("Failed to download the CSV file.");
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "An error occurred while fetching the data.";
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (onSearch) {
      onSearch(searchInput);
    }
  }, [onSearch]);

  return (
    <>
      <Loader loaderOpen={isImporting} />
      {Heading?.map((data) => (
        <div
          key={data.id}
          className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.py1} ${classes.px1_5} ${classes.inputborder}`}
        >
          <div className={`${classes.dflex} ${classes.alignitemscenter}`}>
            {data.allcomments && (
              <div>
                <Button
                  className={`${classes.border1} ${classes.textcolorblue} ${classes.fontFamilyInter} ${classes.fontSize08} ${classes.fw500}`}
                  onClick={() => {
                    navigate("/admin/allcomments");
                  }}
                >
                  All Comments <AllCommentIcon className={`${classes.ml1}`} />
                </Button>
              </div>
            )}
            {data.import && (
              <div>
                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileInputChange}
                  accept=".csv"
                />
                <Button
                  onClick={() => fileInputRef.current.click()}
                  className={`${classes.custombtnoutline} ${classes.ml1}`}
                >
                  Import Excel File <ImportIcon className={`${classes.ml1}`} />
                </Button>
              </div>
            )}
            {data.export && (
              <div>
                <Button
                  onClick={handleExport}
                  className={`${classes.custombtnblue} ${classes.ml1}`}
                >
                  Export File <ExportIcon className={`${classes.ml1}`} />
                </Button>
              </div>
            )}
          </div>

          <div className={`${classes.dflex} ${classes.alignitemscenter}`}>
            {data.dateSearch && (
              <div className={`${classes.dflex} ${classes.alignitemscenter} ${classes.mr1}`}>
                <TextField
                  className={`${classes.textcolorformlabel} ${classes.fontsize3}`}
                  type="date"
                  variant="outlined"
                  required
                  placeholder={data.inputplaceholder}
                  value={dateInput}
                  onChange={(e) => {
                    setDateInput(e.target.value);
                    if (onDateSearch) {
                      onDateSearch(e.target.value);
                    }
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            )}

            {(data.inputplaceholder || data.inputlable) && (
              <div className={`${classes.dflex} ${classes.alignitemscenter}`}>
                {data.inputlable && data.inputlable.trim() !== "" && (
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight} ${classes.mr1}`}
                  >
                    {data.inputlable}
                  </FormLabel>
                )}
                <div className={`${classes.dflex}`}>
                  <TextField
                    className={`${classes.textcolorformlabel} ${classes.fontsize3}`}
                    type="text"
                    variant="outlined"
                    required
                    placeholder={data.inputplaceholder}
                    value={searchInput}
                    onChange={handleInputChange}
                  />
                  <Button
                    className={`${classes.custombtnblue} ${classes.ml1}`}
                    onClick={() => onSearch && onSearch(searchInput)}
                  >
                    Search
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default TableViewSearch;
